// JustUpdatedToast.jsx — auto-shown for 4 seconds on the first page load
// AFTER a service-worker-driven update has completed. Reads a flag persisted
// in localStorage by pwa.js, then clears it.
import React, { useEffect, useState } from "react";
import { consumeJustUpdatedFlag } from "./lib/pwa";
import { APP_VERSION } from "./lib/version";

export default function JustUpdatedToast() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (consumeJustUpdatedFlag()) {
      setShow(true);
      const t = setTimeout(() => setShow(false), 4500);
      return () => clearTimeout(t);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="just-updated-toast" data-testid="just-updated-toast" role="status" aria-live="polite">
      <span className="jut-icon" aria-hidden>✓</span>
      <div className="jut-text">
        <div className="jut-title">التطبيق محدّث لآخر نسخة</div>
        <div className="jut-sub">{APP_VERSION}</div>
      </div>
      <button
        type="button"
        className="jut-close"
        aria-label="إغلاق"
        data-testid="jut-close"
        onClick={() => setShow(false)}
      >×</button>
    </div>
  );
}
